import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { SubscriptionExpiredModal } from 'components/Modal/TrialEndedModal/SubscriptionExpiredModal'
import EducationTransferringToNewFreePlanModal from '../../../components/Modal/TrialExtensionModal/EducationTransferringToNewFreePlanModal'
import UpgradeDialog from 'components/Modal/UpgradeDialog/UpgradeDialog'
import DeleteProjectModal from './DeleteProjectModal/DeleteProjectModal'
import ShareProjectModal from './ShareProjectModal/ShareProjectModal'
import ManageTeamModal from './ManageTeamModal/ManageTeamModal'
import InvitationSentByEmailModal from './InvitationSentByEmailModal/InvitationSentByEmailModal'
import DecisionOrganizationInviteModal from './DecisionOrganizationInviteModal/DecisionOrganizationInviteModal'

export const MODAL_TYPES = {
    deleteProjectModal: 'deleteProjectModal',
    subscriptionExpired: 'subscriptionExpired',
    educationModal: 'educationModal',
    publishModal: 'publishModal',
    shareModal: 'shareModal',
    manageTeamModal: 'manageTeamModal',
    invitationSentByEmailModal: 'invitationSentByEmailModal',
    decisionOrganizationInviteModal: 'decisionOrganizationInviteModal',
    upgradeDialog: 'upgradeDialog',
}
const ModalController = ({ openedModals = [], onCloseModal, onDeleteProject, onOpenModal }) => {
    const { t } = useTranslation()
    const history = useHistory()

    return Array.isArray(openedModals)
        ? openedModals.map((modal = {}) => {
              switch (modal.type) {
                  case MODAL_TYPES.deleteProjectModal: {
                      return (
                          <DeleteProjectModal
                              key={modal.type}
                              data={modal.payload}
                              onCloseModal={() => onCloseModal(MODAL_TYPES.deleteProjectModal)}
                              onDeleteProject={onDeleteProject}
                          />
                      )
                  }
                  case MODAL_TYPES.subscriptionExpired: {
                      return (
                          <SubscriptionExpiredModal
                              key={modal.type}
                              onClose={() => onCloseModal(MODAL_TYPES.subscriptionExpired)}
                          />
                      )
                  }
                  case MODAL_TYPES.educationModal: {
                      return (
                          <EducationTransferringToNewFreePlanModal
                              key={modal.type}
                              onClose={() => onCloseModal(MODAL_TYPES.educationModal)}
                          />
                      )
                  }
                  case MODAL_TYPES.publishModal: {
                      return (
                          <ShareProjectModal
                              key={modal.type}
                              isPublished
                              title={modal.payload.title}
                              data={modal.payload}
                              onClose={() => onCloseModal(MODAL_TYPES.publishModal)}
                          />
                      )
                  }
                  case MODAL_TYPES.shareModal: {
                      return (
                          <ShareProjectModal
                              key={modal.type}
                              title={t('Share your project')}
                              data={modal.payload}
                              onClose={() => onCloseModal(MODAL_TYPES.shareModal)}
                          />
                      )
                  }
                  case MODAL_TYPES.manageTeamModal: {
                      return (
                          <ManageTeamModal
                              key={modal.type}
                              onOpenModal={onOpenModal}
                              onClose={() => onCloseModal(MODAL_TYPES.manageTeamModal)}
                          />
                      )
                  }
                  case MODAL_TYPES.invitationSentByEmailModal: {
                      return (
                          <InvitationSentByEmailModal
                              key={modal.type}
                              onClose={() => onCloseModal(MODAL_TYPES.invitationSentByEmailModal)}
                          />
                      )
                  }
                  case MODAL_TYPES.decisionOrganizationInviteModal: {
                      return (
                          <DecisionOrganizationInviteModal
                              key={modal.type}
                              data={modal.payload}
                              onClose={() => onCloseModal(MODAL_TYPES.decisionOrganizationInviteModal)}
                          />
                      )
                  }
                  case MODAL_TYPES.upgradeDialog: {
                      return (
                          <UpgradeDialog
                              onClose={() => onCloseModal(MODAL_TYPES.upgradeDialog)}
                              onUpgrade={() => history.push('/billing-and-payments?tab=subscription')}
                              data={modal.payload}
                          />
                      )
                  }
                  default: {
                      return null
                  }
              }
          })
        : null
}

export default ModalController
